export default __webpack_public_path__ + "static/media/diamond-necklace.cea72f61.webp";